export default "__VITE_ASSET__BG6_F7Bf__"